import styled from '@emotion/styled'
import { css } from '@emotion/react'

import env from '@/lib/env'

const Container = styled.section`
  --widget-width: 642px;

  & {
    width: 100%;
    position: relative;
  }

  .container {
    width: ${({ theme }) => theme.size.width[90]};
    max-width: ${({ theme }) => theme.size.width[900]};
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: column nowrap;
    margin: auto;
    padding: 113px 0 53px 0;
    position: relative;
  }

  .decorator-container {
    overflow: visible;
    max-height: 0px;
  }

  #top-pane-image {
    width: calc(50% + 391px);
    height: 80%;
    max-height: 854px;
    object-fit: cover;
    position: absolute;
    z-index: 0;
    background-image: url('${
      env.BASE_PATH
    }/static/images/istockphoto-528045706/istockphoto-528045706-2048-x-2048.jpg');
    background-position: bottom right;
    background-repeat: no-repeat;
    background-size: cover;
  }

  #group-29 {
    position: absolute;
    top: 42em;
    right: 0;
    width: 22%;
    max-width: 438px;
  }

  #group-22 {
    position: absolute;
    width: calc(100% - 1440px);
    max-width: 121px;
    left: 6vw;
    top: 12vw;
  }

  #group-13 {
    position: absolute;
    width: calc(100% - 1440px);
    max-width: 121px;
    left: 0;
    bottom: 5vw;
  }

  .rectangle-container {
    top: 30%;
    left: calc(50% + 291px);
    position: absolute;
    width: 23%;
    max-width: 469px;
    transform: translate3d(0, -50%, 0);
    overflow: visible;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: row nowrap;
  }

  .rectangle-container > section {
    width: calc(100vw - 1740px);
    max-width: 143px;
    overflow: visible;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: column nowrap;
    position: absolute;
    right: 0;
    top: 0;
    transform: translate3d(calc(100% + 24px), 0, 0);
  }

  #top-pane-image-2-container {
    width: 100%;
    padding: 100% 0 0 0;
    position: relative;
    top: 34px;
    left: 0;
  }

  #top-pane-image-2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 138%;
    overflow: hidden;
    border-radius: 48px 48px 0 48px;
    box-shadow: 6px 6px 16px 0 ${({ theme }) => theme.colors.gray[900]}66;
  }

  #group-1 {
    width: 100%;
  }

  #group-2 {
    width: 70%;
    margin: 0 0 14px 0;
  }

  .container > h1 {
    line-height: normal;
    font-weight: 500;
    font-size: var(--fs-900);
    color: ${({ theme }) => theme.colors.gray[0]};
    margin: 0 0 17px 0;
  }

  .container > h1 > span.primary {
    color: ${({ theme }) => theme.colors.primary[400]};
  }

  .container > h2 {
    line-height: normal;
    font-weight: 300;
    font-size: var(--fs-700);
    color: ${({ theme }) => theme.colors.gray[0]};
    margin: 0 0 60px 0;
  }

  .widget-container {
    color: ${({ theme }) => theme.colors.gray[900]};
    border: none;
    height: 385px;
    position: relative;
    border-radius: 32px 32px 32px 0;
  }

  .widget-container > figure {
    overflow: visible;
    position: absolute;
    left: 1px;
    top: 1px;
    right: 1px;
    bottom: 1px;
    z-index: 0;
    border-radius: 32px 32px 32px 0;
  }

  .widget-container > article {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    padding: 0;
    background-color: ${({ theme }) => theme.colors.gray[0]};
    border-radius: var(--border-radius);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column nowrap;
    border-radius: 32px 32px 32px 0;
    box-shadow: inset -1px -1px 1px 0 ${({ theme }) => theme.colors.gray[380]};
  }

  .widget-background {
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.primary[400]};
    border-radius: var(--border-radius);
    border-radius: 32px 32px 32px 0;
    transform: translate3d(12px, 12px, -5px);
  }

  .form-container {
    width: 85%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column nowrap;
  }

  .form-container > .form {
    width: 100%;
  }

  .form-container > p {
    font-size: var(--fs-560);
    font-weight: 500;
    line-height: 45px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray[900]};
  }

  .form-container > .secondary {
    white-space: pre-wrap;
    color: ${({ theme }) => theme.colors.secondary[900]};
  }

  .form-container > .primary {
    white-space: pre;
    color: ${({ theme }) => theme.colors.primary[400]};
  }

  .more-info-link {
    cursor: pointer;
    font-weight: 500;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: var(--fs-100);
    text-align: center;
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
  }

  .more-info-link:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  .more-info-link:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  .platform-link {
    width: 100%;
    margin: 16px 0 16px 0;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '.container': {
          alignItems: ['center', 'center', 'center', 'flex-start'],
          paddingTop: ['97px', '97px', '107px', '148px'],
        },
        '.more-info-link': {
          fontSize: [
            'var(--fs-50)',
            'var(--fs-50)',
            'var(--fs-300)',
            'var(--fs-300)',
          ],
        },
        '#top-pane-image': {
          width: ['100%', '100%', '100%', 'calc(50% + 391px)'],
        },
        '#top-pane-image-2': {
          display: ['none', 'none', 'none', 'block'],
        },
        '#group-29, #group-22, #group-13': {
          display: ['none', 'none', 'none', 'block'],
        },
        '.container > h1, .container > h2': {
          textAlign: ['center', 'center', 'center', 'left'],
          width: ['100%', '100%', '100%', '734px'],
        },
        '.container > h1': {
          fontSize: [
            'var(--fs-570)',
            'var(--fs-570)',
            'var(--fs-700)',
            'var(--fs-900)',
          ],
        },
        '.container > h2': {
          fontSize: [
            'var(--fs-300)',
            'var(--fs-300)',
            'var(--fs-570)',
            'var(--fs-700)',
          ],
        },
        '.widget-container': {
          width: ['100%', '100%', '642px', '642px'],
          height: ['320px', '300px', '385px', '385px'],
          padding: ['8px 0', '8px 0', '16px 0'],
        },
        '.widget-background': {
          transform: [
            'translate3d(5px, 5px, -5px)',
            'translate3d(5px, 5px, -5px)',
            'translate3d(7px, 7px, -5px)',
            'translate3d(12px, 12px, -5px)',
          ],
        },
        '.widget-container > figure, .widget-container > article': {
          width: ['calc(97%)', 'calc(97%)', 'calc(97%)', '100%'],
        },
        '.form-container > p': {
          padding: ['0 0', '0 0', '8px 0'],
        },
        '.form-container > .small': {
          fontSize: ['var(--fs-200)', 'var(--fs-300)', 'var(--fs-550)'],
        },
        '.form-container > .large': {
          fontSize: ['var(--fs-300)', 'var(--fs-400)', 'var(--fs-600)'],
        },
      }),
    ).styles}};
`

export default Container
